import React from 'react'

function AccessDenied() {
    return (
        <h1>
            AccessDenied
        </h1>
    )
}

export default AccessDenied
